import { Button, ButtonProps } from "antd";
import { withClickTracking } from "hooks/useAnalytics";
import { AnalyticsEventsMap } from "types/analytics";

type TrackedButtonProps<T extends keyof AnalyticsEventsMap> = ButtonProps & {
  trackingEventName?: T;
  trackingProps?: AnalyticsEventsMap[T];
  trackingName?: string;
  trackingText?: string;
};

export const TrackedButton = withClickTracking<
  ButtonProps,
  keyof AnalyticsEventsMap
>(Button) as <T extends keyof AnalyticsEventsMap>(
  props: TrackedButtonProps<T>
) => JSX.Element;
